import Yup from '../yup';
import person from './person';

const protectedPersons = {
  prp_person: Yup.string()
    .trim()
    .required(
      'Please indicate whether you are the protected person in the original order'
    ),
  prp_ord_fc: Yup.string()
    .trim()
    .required(
      'Please indicate whether there are any Family Law Act orders, Child Protection orders, or current applications'
    ),
  protected_persons: Yup.array().when('prp_person', {
    is: (prp_person?: string) => prp_person === 'no',
    then: Yup.array().of(person()),
  }),
};

export default protectedPersons;
